
import { CircleChevronLeft, Search } from "lucide-react";
import ReturnHistoryTable from "../components/Inventory-Stocks & Orders/Admin/InventoryManagement/ReturnHistoryTable";
import { useState } from "react";

const formStyles = {
  label: "block text-sm text-[#3F5260] font-medium mb-1",
  input:
    "w-full px-3 py-2 border border-[#D0D5DE] outline-none rounded-lg focus:ring-1 focus:ring-emerald-500 text-sm",
};

const ReturnItemEntryModal = ({ onClose }: { onClose: () => void }) => {
  const [formData, setFormData] = useState({
    invoiceNumber: "",
    productName: "",
    reason: "",
    quantity: "",
  });

  const [isVerified, setIsVerified] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleVerify = () => {
    if (
      formData.invoiceNumber &&
      formData.productName &&
      formData.reason &&
      formData.quantity
    ) {
      setIsVerified(true);
    } else {
      alert("Please fill all fields before verifying.");
    }
  };

  return (
    <div className="flex w-full">
      <div className="w-full">
        <div className="flex items-center mb-4">
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <CircleChevronLeft className="w-6 h-6 bg-[#808080] text-white rounded-full mr-2" />
          </button>
          <h2 className="text-xl font-semibold text-gray-800">Return Item Entry</h2>
        </div>

        <div className="flex gap-6 w-full">
          {/* Left Section */}
          <div className="border border-gray-300 bg-white rounded-xl p-4 w-2/3 min-h-[560px] flex flex-col justify-between">
            <div className="text-green-600 font-semibold mb-4">RETURN ITEM</div>
            <div className="space-y-6">
              <div>
                <label className={formStyles.label}>Enter Invoice Number</label>
                <input
                  type="text"
                  name="invoiceNumber"
                  value={formData.invoiceNumber}
                  onChange={handleChange}
                  className={formStyles.input}
                  placeholder="Enter Invoice Number"
                />
              </div>

              <div>
                <label className={formStyles.label}>Select Product Name</label>
                <input
                  type="text"
                  name="productName"
                  value={formData.productName}
                  onChange={handleChange}
                  className={formStyles.input}
                  placeholder="Select Product Name"
                />
              </div>

              <div>
                <label className={formStyles.label}>Reason To Return</label>
                <textarea
                  name="reason"
                  value={formData.reason}
                  onChange={handleChange}
                  className={`${formStyles.input} resize-none h-[120px]`}
                  placeholder="Enter Reason To Return"
                />
              </div>

              <div>
                <label className={formStyles.label}>Number of Items</label>
                <input
                  type="text"
                  name="quantity"
                  value={formData.quantity}
                  onChange={handleChange}
                  className={formStyles.input}
                  placeholder="Enter Number of items"
                />
              </div>
            </div>

            <div className="mt-6">
              <button
                onClick={handleVerify}
                className={`bg-green-600 hover:bg-green-700 text-white font-medium px-4 py-2 rounded-md`}
              >
                {isVerified ? "Mark as Return" : "Verify"}
              </button>
            </div>
          </div>

          {/* Right Section */}
          <div className="border border-gray-300 bg-white rounded-xl p-4 w-[45%] min-h-[560px]">
            <div className="text-green-600 font-semibold mb-4">ITEM DETAILS</div>

            {!isVerified ? (
              <div className="flex items-center justify-center flex-col text-center text-gray-500 h-[calc(100%-2rem)]">
                <svg
                  className="w-16 h-16 mb-3 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  viewBox="0 0 24 24"
                >
                  <path d="M9 17h6M9 13h6M9 9h6M4 6h16M4 6v12a2 2 0 002 2h12a2 2 0 002-2V6M4 6l8 8 8-8" />
                </svg>
                <p>Please verify item to get product details</p>
              </div>
            ) : (
          <div>
              <div className="mb-4">
                <div className="text-sm font-medium text-gray-700 mb-3">Product Photo</div>
                <img 
                  src="https://picsum.photos/300/200?random=1" 
                  alt="Product" 
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
              </div>
              <div className="mb-4 pb-3">
                <div className="text-sm font-medium text-gray-700 mb-1">Product Price</div>
                <div className="text-2xl font-bold text-green-600">₹ 258.00</div>
              </div>
              <div>
                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div>
                    <div className="text-sm font-medium text-gray-700 mb-1">Product Name</div>
                    <div className="text-sm text-gray-900">Benadryl Allergy Ultra</div>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-gray-700 mb-1">Product ID</div>
                    <div className="text-sm text-gray-900">4258746322</div>
                  </div>
                </div>

                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <div className="text-sm font-medium text-gray-700 mb-1">Manufacturer</div>
                    <div className="text-sm text-gray-900">Dr Reddy's</div>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-gray-700 mb-1">Batch Number</div>
                    <div className="text-sm text-gray-900">KA24205</div>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-gray-700 mb-1">Expiry Date</div>
                    <div className="text-sm text-gray-900">24/01/2027</div>
                  </div>
                </div>
              </div>
            </div>
            )}
          </div>
        </div>

        {/* Return History */}
        <div className="flex justify-between items-center bg-white rounded-t-xl -mb-6 shadow-sm mt-6">
          <div className="px-4 text-green-600 font-semibold">RETURN HISTORY</div>
          <div className="flex items-center justify-end gap-4 p-4 border-b">
            <span className="text-sm text-gray-600">🔽 Filter</span>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
              <input
                type="text"
                placeholder="Search..."
                className="pl-10 pr-4 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
            </div>
          </div>
        </div>

        <div className="mb-4">
          <ReturnHistoryTable />
        </div>
      </div>
    </div>
  );
};

export default ReturnItemEntryModal;